import { LinkButton, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import * as style from './LinksButton.css';
import classNames from 'classnames';

export const LinksButton: React.FC = () => {
  const device = useDeviceType();

  const isDevice = device !== 'desktop';

  return (
    <div className={classNames(style['button'], isDevice && style['button-tablet'])}>
      <LinkButton
        href="https://promo.cian.site/crm/?cian_source=landing_in&cian_medium=landing&cian_campaign=b2b_rf_product_crm_all_mix&cian_content=top"
        target="_blank"
        size={isDevice ? 'XS' : 'M'}
        beforeIcon={<div className={style['crm-icon']} />}
      >
        Каталог CRM-систем
      </LinkButton>
      <LinkButton
        size={isDevice ? 'XS' : 'M'}
        href="https://www.cian.ru/franchise/?cian_source=landing_in&cian_medium=landing&cian_campaign=b2b_rf_product_rating_franchise_all_mix&cian_content=top"
        target="_blank"
        beforeIcon={<div className={style['image-icon']} />}
      >
        Каталог франшиз
      </LinkButton>
    </div>
  );
};
